import React from 'react';

const EmailAndPhone = ({ rowData }) => {
    return (
        <span className="flex flex-col items-center justify-center">
            {rowData.email && (
                <span>
                    {rowData.email}
                </span>
            )}
            {rowData.phone_number && (
                <span>
                    {rowData.phone_number}
                </span>
            )}
        </span>
    );
}

export default EmailAndPhone;
